import {Component} from '@angular/core';
import {UserService} from '../../services/user.service';
import {Router} from '@angular/router';
import {ProgressService} from '../../services/progress.service';
import {FormControl, Validators} from '@angular/forms';
import {SnackService} from '../../services/snack.service';
import {User} from '../../model/Entities/User';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {

    credentials = {
        email: '',
        password: ''
    };

    emailFC = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    passwordFC = new FormControl('', [
        Validators.required,
    ]);

    constructor(private userService: UserService,
                private progressService: ProgressService,
                protected snackService: SnackService,
                private router: Router) {

    }

    login() {
        this.progressService.startLoading('login');
        this.userService
            .login(this.credentials)
            .subscribe((session: any) => {
                    const u: User = session.user;
                    this.snackService.showSuccess('Uživatel ' + u.name + ' ' + u.surname + ' byl úspěšně přihlášen');
                    this.router.navigate(['dashboard']);
                    this.progressService.stopLoading('login');
                },
                () => {
                    this.snackService.showWarn('Byly zadány neplatné přihlašovací údaje');
                }
            );
    }

    checkFormValidity() {
        return this.emailFC.valid && this.passwordFC.valid;
    }
}



// WEBPACK FOOTER //
// /app/src/AppModule/LoginComponent/login.component.ts